import {
  SimpleChange,
  ElementRef,
  Component,
  OnChanges,
  ViewChild,
  Input,
} from "@angular/core";

// Environments
import { environment } from "src/environments/environment";

// Services
import { StaticPageService } from "src/app/modules/static-pages/services/static-page.service";

@Component({
  selector: "app-reward-bonus-terms-condtions",
  templateUrl: "./reward-bonus-terms-condtions.component.html",
  styleUrls: ["./reward-bonus-terms-condtions.component.scss"],
})
export class RewardBonusTermsCondtionsComponent implements OnChanges {
  @Input() urlpath: string;
  @ViewChild("dynamicContent", { static: true }) el: ElementRef;
  isLoading: boolean = true;
  isPageAvailable: any;

  constructor(private staticPageService: StaticPageService) {}

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes["urlpath"]) {
      this.urlpath = changes["urlpath"].currentValue;
      if (this.urlpath) {
        this.loadStaticPage(this.urlpath);
      }
    }
  }

  loadStaticPage(urlpath) {
    /**re-initializing the properties before
     * every request...
     */
    Promise.resolve(this.staticPageService.getStaticPagep(urlpath, false)).then(
      (staticPageData) => {
        /**block to handle if no content is configured for this
         * specific path
         * */
        this.isLoading = false;
        if (
          !Object.keys(staticPageData).length ||
          staticPageData["errorCode"]
        ) {
          this.isPageAvailable = false;
        } else {
          /**block to handle successfull content from cms.. */
          this.isPageAvailable = true;
          /**replacing all the regex like {{site_url}} with environment
           * siteurl
           */
          const staticContent = staticPageData["content"].replace(
            new RegExp("{{site_url}}", "g"),
            environment.siteUrl
          );
          setTimeout(() => {
            if (this.el && this.el.nativeElement) {
              this.el.nativeElement.innerHTML = staticContent;
            }
          });
        }
      }
    );
  }
}
